export default function AvailableBadge({ available = true, testid }) {
  if (!available) {
    return (
      <span data-testid={testid} className="flex items-center gap-1.5 rounded-full bg-zinc-950/80 backdrop-blur border border-zinc-700 text-zinc-400 text-[10px] font-medium uppercase tracking-wider whitespace-nowrap px-2 sm:px-2.5 py-1">
        <span className="h-1.5 w-1.5 rounded-full bg-zinc-500" />
        <span className="sm:hidden">Niet vandaag</span><span className="hidden sm:inline">Vandaag niet beschikbaar</span>
      </span>
    );
  }
  return (
    <span data-testid={testid} className="flex items-center gap-1.5 rounded-full bg-emerald-500/90 text-emerald-950 text-[10px] font-semibold uppercase tracking-wider whitespace-nowrap px-2 sm:px-2.5 py-1 shadow-lg shadow-emerald-950/40">
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-75" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-white" />
      </span>
      <span className="sm:hidden">Vandaag</span><span className="hidden sm:inline">Vandaag beschikbaar</span>
    </span>
  );
}
